import { Controller } from '@hotwired/stimulus';
import { Carousel } from 'bootstrap';

export default class extends Controller {
  connect() {
    this.initializeCarousels();
  }

  disconnect() {
    this.destroyCarousels();
  }

  initializeCarousels = () => {
    const carousels = this.element.querySelectorAll('.carousel');
    this.carousels = [];

    carousels.forEach((carousel) => {
      Carousel.getOrCreateInstance(carousel, {
        touch: true,
      });
      this.carousels.push(carousel);
    });
  };

  destroyCarousels() {
    if (this.carousels) {
      this.carousels.forEach((carousel) => {
        carousel.dispose();
      });
    }
    this.carousels = [];
  }
}
